<template>
  <MenuCategoryScreen :slug="slug" />
</template>

<script setup lang="ts">
// Тонкая обёртка над экраном: маршрут Nuxt отдаёт slug, всё остальное — в ui/.
import { computed } from 'vue'
import MenuCategoryScreen from './ui/MenuCategoryScreen.vue'

const route = useRoute()
const slug = computed(() => String(route.params.slug || ''))
</script>
